import { render } from "./BaseSort.vue?vue&type=template&id=1d553c3d"
import script from "./BaseSort.vue?vue&type=script&lang=js"
export * from "./BaseSort.vue?vue&type=script&lang=js"

import exportComponent from "/Users/maksimzugan/code/nacd-3-family/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__